module.exports = __webpack_public_path__ + "img/jpg.02dac463.png";